
import { Component, Vue } from "vue-property-decorator";
import Pagination from "@/components/Pagination/index.vue";
import CommunicationDialog from "./communicationDialog.vue";
import DealDialog from "./dealDialog.vue";
import UnsubscribeDialog from "./unsubscribeDialog.vue";
import VipDaysDialog from "./vipDaysDialog.vue";
import DetailDialog from "./detailDialog.vue";
import {
    OrderRecordService,
    OrderRecordRegistrationBySchoolIdDto,
    RegistrationType,
    OrderRecordState,
} from "@/api/service-proxies";
import PagedListBase, {
    PagedRequestDto,
} from "@/lib/view-base/paged-list-base";
import { __param } from "tslib";
import moment from "moment";
import { warn } from "vue-class-component/lib/util";
import appconst from "@/lib/appconst";

class OrderRecordRegistrationBySchoolIdInput extends PagedRequestDto {
    name: string;
    schoolName: string;
    gradeNo!: number;
    classNo!: number;
    majorName: string;
    majorClassNo: string;
    registrationType!: RegistrationType;
    orderRecordState!: OrderRecordState;
    startTime!: moment.Moment;
    endTime!: moment.Moment;
    tenantId!: number;
}
@Component({
    name: "user-registration",
    components: {
        Pagination,
        CommunicationDialog,
        DealDialog,
        VipDaysDialog,
        DetailDialog,
        UnsubscribeDialog,
    },
})
export default class UserRegistration extends PagedListBase<
    OrderRecordRegistrationBySchoolIdInput,
    OrderRecordRegistrationBySchoolIdDto
> {
    request = new OrderRecordRegistrationBySchoolIdInput();
    private orderRecordService = new OrderRecordService();

    private editDialogVisible = false;
    private isLoading = false;
    allRegistrationCount = 0;
    allDealCount = 0;
    allUnsubscribeCount = 0;
    $http: any;
    date = [];

    isTableLoading = false;
    isTableLoadingTable = false;


    mounted() {
        this.getOrderRecordRegistration();
    }
    success() {
        this.getOrderRecordRegistration();
    }
    getpage(): void {
        this.getOrderRecordRegistration();
    }
    created() {

        //this.refresh()
        //this.$router.push({ name: "unicomRegistration" })
    }

    //点击查询按钮
    search() {
        this.currentPage = 0;
        this.request.skipCount = 0;
        this.getOrderRecordRegistration();
    }

    //获取列表
    getOrderRecordRegistration() {
        this.isTableLoading = true;
        this.orderRecordService
            .getOrderRecordRegistrationAll(
                this.request.name,
                this.request.schoolName,
                this.request.gradeNo,
                this.request.classNo,
                this.request.majorName,
                this.request.majorClassNo,
                this.request.registrationType,
                this.request.orderRecordState,
                this.request.startTime,
                this.request.endTime,
                this.request.sorting,
                null,
                0,
                this.request.skipCount,
                this.request.maxResultCount
            )
            .then((result) => {

                this.list = result.items;
                this.allDealCount = result.allDealCount;
                this.allRegistrationCount = result.allRegistrationCount;
                this.allUnsubscribeCount = result.allUnsubscribeCount;
                this.showPaging(result);
            })
            .finally(() => {
                this.isTableLoading = false;
            });
    }
    divClick(i) {
        this.$router.push({
            name: "allSchoolRecord",
            params: { state: i},
        });
    }
    dateChange(e) {
        if (e) {
            this.request.startTime = moment(this.date[0]);
            this.request.endTime = moment(this.date[1]);
        } else {
            this.request.startTime = null;
            this.request.endTime = null;
        }
    }

    //根据不同业务 打开不同弹框  查看-0  退订-1  办理-2  会员-3 4-沟通记录
    operationDialog(row, type) {

        if (type == 0 && row.orderRecordState == 6) {
            (this.$refs.detailRef as DetailDialog).open(row);
        } else if (type == 0 && row.orderRecordState != 6) {
            (this.$refs.unsubscribeRef as UnsubscribeDialog).open(
                row.id,
                row.orderRecordState,
                row.tenantId
            );
        } else if (type == 1) {
            (this.$refs.unsubscribeRef as UnsubscribeDialog).open(
                row.id,
                row.orderRecordState,
                row.tenantId
            );
        } else if (type == 2) {
            (this.$refs.dealRef as DealDialog).open(row, row.tenantId);
        } else if (type == 3) {
            (this.$refs.vipDaysRef as VipDaysDialog).open(
                row.id,
                row.tenantId,
                row.studentName,
                row.className,
                row.faceImg
            );
        } else if (type == 4) {
            (this.$refs.communicationRef as CommunicationDialog).open(
                row.id,
                row.tenantId
            );
        }
    }

    currentClassChange(event: any) {
        this.request.gradeNo = event.gradeNo;
        this.request.classNo = event.classNo;
    }

    //导出
    exportExcel() {
        this.$http
            .post(
                appconst.remoteServiceBaseUrl +
                    "sysadmin/api/ExportUnicomRegistration/ExportUnicomRegistration",
                {
                    name: this.request.name,
                    schoolName: this.request.schoolName,
                    gradeNo: this.request.gradeNo,
                    classNo: this.request.classNo,
                    majorName: this.request.majorName,
                    majorClassNo: this.request.majorClassNo,
                    registrationType: this.request.registrationType,
                    orderRecordState: this.request.orderRecordState,
                    startTime: this.request.startTime,
                    endTime: this.request.endTime,
                },
                {
                    responseType: "arraybuffer",
                }
            )
            .then((res) => {
                let a = document.createElement("a");
                let blob = new Blob([res], {
                    type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
                });

                a.href = URL.createObjectURL(blob);
                a.download = "联通登记表.xlsx";
                a.click();

                URL.revokeObjectURL(a.href);
            })
            .finally(() => {
                //this.isExporting = false;
                //this.dialogVisible = false;
            });
    }
}
